import clientAxios from '../../config/axios';
import { configOptions } from '../../helpers/axios';
import { countryQuery } from '../constants';

export const getAllComments = ({ page, housekey_id }: any, token: string) => {
  const query = new URLSearchParams();
  query.set('page', page);
  query.set('housekey_id', housekey_id);
  query.set('country', process.env.REACT_APP_ENV_COUNTRY || '');
  query.set('limit', '10');
  const url = `/key/comments?${query}`;
  return clientAxios.get(url, configOptions(token));
};

export const updateComment = (comment: any, token: string) => {
  const url = `/key/comments?${countryQuery}&id=${comment.id}`;
  return clientAxios.put(url, comment, configOptions(token));
};

export const createComment = (comment: any, token: string) => {
  const url = `/key/comments?${countryQuery}`;
  return clientAxios.post(url, comment, configOptions(token));
};
